/**
 * Dark Mode Initialization Script
 *
 * This script runs BEFORE Angular app initialization to prevent
 * flash of wrong theme (FOUT - Flash of Unstyled Theme).
 *
 * It applies the dark theme class immediately based on:
 * 1. localStorage preference
 * 2. Device preference (prefers-color-scheme)
 *
 * This should be loaded as early as possible in index.html
 */
(function () {
    'use strict';

    var STORAGE_KEY = 'endeksa-dark-mode';

    /**
     * Get dark mode preference from query string, localStorage, or device
     */
    function shouldUseDarkMode() {
        // 1. Check query string first (highest priority - for deep links, sharing, etc.)
        try {
            var queryString = new URL(window.location.toString()).searchParams;
            var themeParam = queryString.get('theme');

            if (themeParam === 'dark') {
                // Store in localStorage for persistence
                localStorage.setItem(STORAGE_KEY, 'dark');
                return true;
            }
            if (themeParam === 'light') {
                // Store in localStorage for persistence
                localStorage.setItem(STORAGE_KEY, 'light');
                return false;
            }
        } catch (e) {
            // URL parsing failed - continue to next check
            console.warn('Unable to parse URL for theme parameter');
        }

        // 2. Check localStorage (manual user preference)
        try {
            var storedPreference = localStorage.getItem(STORAGE_KEY);
            if (storedPreference === 'dark') {
                return true;
            }
            if (storedPreference === 'light') {
                return false;
            }
        } catch (e) {
            // localStorage not available (privacy mode, etc.)
            console.warn('localStorage not available for dark mode');
        }

        // 3. Check device preference
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            return true;
        }

        // 4. Default to light mode
        return false;
    }

    /**
     * Apply dark theme class immediately
     */
    function applyDarkMode() {
        var darkMode = shouldUseDarkMode();
        var htmlElement = document.documentElement;
        var bodyElement = document.body;

        if (darkMode) {
            htmlElement.classList.add('dark-mode');
            // Body class will be added when body element is available
            if (bodyElement) {
                bodyElement.classList.add('dark-mode');
            } else {
                // Add body class when DOM is ready
                document.addEventListener('DOMContentLoaded', function () {
                    document.body.classList.add('dark-mode');
                });
            }
            window.darkMode = true;
        } else {
            htmlElement.classList.remove('dark-mode');
            if (bodyElement) {
                bodyElement.classList.remove('dark-mode');
            }
            window.darkMode = false;
        }
    }

    // Apply theme immediately
    applyDarkMode();

    // Listen for storage changes from other tabs
    window.addEventListener('storage', function (e) {
        if (e.key === STORAGE_KEY) {
            applyDarkMode();
        }
    });

    // Expose utility for debugging
    window.darkModeUtil = {
        isActive: function () {
            return document.documentElement.classList.contains('dark-mode');
        },
        enable: function () {
            localStorage.setItem(STORAGE_KEY, 'dark');
            applyDarkMode();
        },
        disable: function () {
            localStorage.setItem(STORAGE_KEY, 'light');
            applyDarkMode();
        },
        reset: function () {
            localStorage.removeItem(STORAGE_KEY);
            applyDarkMode();
        }
    };
})();
